/* 
  HomePage.js: Home Landing page for the Nisa and Sabir Foundation website
  @author Miriam Khan 
  @date 11-2-24
*/

import '../../styles/HomePage.css'; 

import OurMission  from './OurMission';
import CallToAction from './CallToAction';
import OurStory    from './OurStory';
import LearnMore   from './LearnMore';

export default function HomePage() {
  return (
    <div>
      <OurMission />

      <div className="second-section flex bg-gray-100 pt-25 mb-[80px]">
        <CallToAction />
        <OurStory />
      </div>

      <section id="learn-more">
        <LearnMore />
      </section>
    </div>
  );
}
